import { useContext, useState, useEffect } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./PigLauncher.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { pigState, loadPig, updatePigSignals } from "./PigEngine";

import { trackPageVisit } from "../competency/PageTracker";

/* ================= VALVE OUTPUT ================= */

function ValveOutput({ value, x, y, r = 0 }) {

  return (

    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        color: "white",
        fontSize: "10px",
        padding: "2px 6px",
        borderRadius: "4px",
        transform: `rotate(${r}deg)`,
        transformOrigin: "center"
      }}
    >
      {(Number(value) || 0).toFixed(1)}
    </div>
  );
}

function PigLauncher() {

        useEffect(() => {
  
    trackPageVisit("PigLauncher");
  
  }, []);

  const {
    valves,
    toggleValve
  } = useContext(WellContext);

  /* ================= CONTROL VALVE DATA ================= */

  const DEFAULT_VALVES = {

    FCV_10901: {
      mode: "Manual",
      opening: 0,
      sp: "",
      pv: ""
    }

  };

  const [valveData, setValveData] = useState(() => {

    const saved =
      localStorage.getItem("TestSeparator_valveData");

    if (!saved) return DEFAULT_VALVES;

    try {

      const parsed = JSON.parse(saved);

      return {

        FCV_10901: {
          ...DEFAULT_VALVES.FCV_10901,
          ...parsed.FCV_10901
        }

      };

    } catch {

      return DEFAULT_VALVES;
    }
  });

  /* ================= SAVE ================= */

  useEffect(() => {

    localStorage.setItem(
      "TestSeparator_valveData",
      JSON.stringify(valveData)
    );

  }, [valveData]);

  /* ================= UPDATE ================= */

  const updateValveData = (
    tag,
    field,
    value
  ) => {

    setValveData(prev => ({

      ...prev,

      [tag]: {

        ...(prev[tag] || DEFAULT_VALVES[tag]),

        [field]:
          field === "opening"
            ? Number(value) || 0
            : value

      }

    }));
  };

  /* ================= PANEL CONTROL ================= */

  const [openPanels, setOpenPanels] =
    useState([]);

  const openPanel = (tag) => {

    if (!openPanels.includes(tag)) {

      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {

    setOpenPanels(prev =>
      prev.filter(p => p !== tag)
    );
  };


// ======================================
// GLOBAL PIG RERENDER
// ======================================

const [, forceRender] = useState(0);

useEffect(() => {

  const renderLoop = setInterval(() => {

    forceRender(v => v + 1);

  }, 30);

  return () => clearInterval(renderLoop);

}, []);




  /* ================= VALVE STATUS ================= */

  const isXV10901Open =
    valves?.XV_10901 === false;

  const isXV10902Open =
    valves?.XV_10902 === false;

  const isXV10903Open =
    valves?.XV_10903 === false;

  const isXV10904Open =
    valves?.XV_10904 === false;

  const isXV10905Open =
    valves?.XV_10905 === false;

  const isXV10906Open =
    valves?.XV_10906 === false;

  const isXV10907Open =
    valves?.XV_10907 === false;

  const isXV10908Open =
    valves?.XV_10908 === false;


    

  /* ================= FLOW LOGIC ================= */

  const FIC_10905 =
    20 *
    (valveData.FCV_10901?.opening || 0) /
    100;

  const FIC_10907 =
    isXV10901Open
      ? FIC_10905
      : 0;

  const FIC_10906 =

    isXV10902Open &&
    isXV10903Open

      ? 520

      : (
          isXV10902Open ||
          isXV10903Open
        )

      ? 300

      : 0;

  const PT_10901 = isXV10902Open || isXV10903Open ? 2.3 : 0.03;

  // 🧠 NEW: realistic pressure drop + delay effect
  const PT_10902 =
    PT_10901 * (1 - FIC_10905 / 1000);

  const TT_10901 = 45 + (FIC_10905 / 20);

  const ZT_10901 = isXV10905Open ? 1 : 0;
  const ZT_10902 = isXV10906Open ? 1 : 0;

  const FIC_10902 = FIC_10906 * 0.85;

  
      

      useEffect(() => {

  updatePigSignals({

    isXV10902Open,
    isXV10903Open,
    isXV10905Open,
    isXV10906Open,
    isXV10907Open,
    isXV10908Open,

    FIC_10906
  });

}, [

  isXV10902Open,
  isXV10903Open,
  isXV10905Open,
  isXV10906Open,
  isXV10907Open,
  isXV10908Open,

  FIC_10906
]);






  return (

    <div className="PigLauncher-container">

      {/* ================= TITLE ================= */}

      <h2
        style={{
          position: "absolute",
          top: "-18px",
          left: "252px",
          color: "white",
          background: "rgba(39,18,233,0.5)",
          padding: "2.2px 301px"
        }}
      >
        PIG LAUNCHER
      </h2>

      {/* ================= LOAD RECTANGLE PIG ================= */}

      <div
        onClick={() => loadPig("rect")}
        onDoubleClick={() => loadPig("circle")}
        title="Single Click = Rectangle Pig | Double Click = Circle Pig"
        style={{
          position: "absolute",
          left: 20,
          top: 230,
          padding: "10px 20px",
          background: "#222",
          color: "white",
          cursor: "pointer",
          border: "2px solid cyan",
          borderRadius: "6px",
          zIndex: 5000,
          userSelect: "none",
          transition: "0.3s"
        }}
      >
        Load Pig
      </div>

      {/* ================= PIG SVG ================= */}

      {
        pigState.visible &&
        pigState.route === "launcher" && (

          <svg
            style={{
              position: "absolute",
              left: pigState.x,
              top: pigState.y,
              overflow: "visible",
              pointerEvents: "none",
              transition:
                "left 0.03s linear, top 0.03s linear",
              zIndex: 4000
            }}
            width={
              pigState.shape === "rect"
                ? 60
                : 35
            }
            height={
              pigState.shape === "rect"
                ? 30
                : 35
            }
          >

            {
              pigState.shape === "rect" ? (

                <rect
                  x="0"
                  y="0"
                  rx="10"
                  ry="10"
                  width="60"
                  height="30"
                  fill="red"
                  stroke="lime"
                  strokeWidth="2"
                />

              ) : (

                <circle
                  cx="17"
                  cy="17"
                  r="10"
                  fill="yellow"
                  stroke="black"
                  strokeWidth="2"
                />

              )
            }

          </svg>
        )
      }

      {/* ================= SHUTDOWN VALVES ================= */}

      <Valve
        tag="XV_10901"
        x={928}
        y={475}
        isClosed={valves.XV_10901}
        toggle={toggleValve}
      />

      <Valve
        tag="XV_10902"
        x={597}
        y={324}
        r={90}
        isClosed={valves.XV_10902}
        toggle={toggleValve}
      />

      <Valve
        tag="XV_10903"
        x={337}
        y={333}
        r={90}
        isClosed={valves.XV_10903}
        toggle={toggleValve}
      />

      <Valve
        tag="XV_10904"
        x={468}
        y={152}
        isClosed={valves.XV_10904}
        toggle={toggleValve}
      />

      <Valve
        tag="XV_10905"
        x={685}
        y={247}
        isClosed={valves.XV_10905}
        toggle={toggleValve}
      />

      <Valve
        tag="XV_10906"
        x={1038}
        y={95}
        isClosed={valves.XV_10906}
        toggle={toggleValve}
      />

      <Valve
        tag="XV_10907"
        x={1026}
        y={300}
        r={90}
        isClosed={valves.XV_10907}
        toggle={toggleValve}
      />

      <Valve
        tag="XV_10908"
        x={387}
        y={438}
        isClosed={valves.XV_10908}
        toggle={toggleValve}
      />

      {/* ================= FCV-10901 ================= */}

      <svg
        width="80"
        height="50"
        viewBox="0 0 200 220"
        style={{
          position: "absolute",
          left: 153,
          top: 60,
          cursor: "pointer"
        }}
        onClick={() => openPanel("FCV_10901")}
      >

        <defs>

          <linearGradient id="metal_10901">

            <stop
              offset="0%"
              stopColor="#bdc3c7"
            />

            <stop
              offset="50%"
              stopColor="#ecf0f1"
            />

            <stop
              offset="100%"
              stopColor="#7f8c8d"
            />

          </linearGradient>

        </defs>

        <path
          d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
          fill="#eb2a11"
          stroke="#3498db"
          strokeWidth="2"
        />

        <rect
          x="95"
          y="90"
          width="10"
          height="70"
          fill="#3d5f2a"
        />

        <polygon
          points="20,200 100,150 20,110"
          fill="url(#metal_10901)"
          stroke="#7f8c8d"
          strokeWidth="2"
        />

        <polygon
          points="180,200 100,150 180,110"
          fill="url(#metal_10901)"
          stroke="#7f8c8d"
          strokeWidth="2"
        />

      </svg>

      {/* ================= FACEPLATES ================= */}

      {
        openPanels.map((tag, index) => (

          <ControlValveControlPanel
            key={tag}
            tag={tag}
            data={valveData[tag]}
            update={updateValveData}
            close={() => closePanel(tag)}
            defaultPosition={{
              x: 300 + index * 40,
              y: 150 + index * 40
            }}
          />

        ))
      }

      {/* ================= OUTPUT ================= */}

      <ValveOutput
        value={valveData.FCV_10901?.opening}
        x={178}
        y={102}
      />

      {/* ================= TRANSMITTERS ================= */}

      <Transmitter
        tag="FIC-10905"
        value={[FIC_10905]}
        x={282}
        y={50}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF NITROGEN TO PIG LAUNCHER FOR PURGING"
      />

      <Transmitter
        tag="FIC-10907"
        value={[FIC_10907]}
        x={1036}
        y={477}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF NITROGEN AND FLUIDS/IMPURITIES TO CLOSE DRAIN AFTER PURGING OF PIG LAUNCHER BARREL"
      />

      <Transmitter
        tag="FIC-10906"
        value={[FIC_10906]}
        x={168}
        y={360}
        unit="SCF/S"
        max={600}
        HH={500}
        H={400}
        L={50}
        LL={20}
        c="lime"
        description="FLOWRATE OF FROM GAS LIFT MANIFOLD/HEADER TO PIG LAUNCHER TO LAUNCH THE PIG FOR PIGGING"
      />

      <Transmitter
        tag="PT-10901"
        value={[PT_10901]}
        x={188}
        y={217}
        unit="MPa"
        max={3}
        HH={2.5}
        H={2}
        L={0.4}
        LL={0.01}
        c="lime"
        description="PRESSURE OF PIG LAUNCHER BARREL DURING PIGGING"
      />



      <Transmitter tag="FIC-10902" value={[FIC_10902]} x={895} y={217} unit="SCF/S" max={350} HH={150} H={250} L={50} LL={20} c="lime" description="FLOWRATE OF PIG LAUNCHER MAIN LINE DURING PIGGING"/>

      <Transmitter tag="PT-10902" value={[PT_10902]} x={734} y={217} unit="MPa" max={3} HH={2.5} H={2} L={0.4} LL={0.04} c="lime" description="PRESSURE OF PIG LAUNCHER MAIN LINE DURING PIGGING"/>

      <Transmitter tag="TT-10901" value={[TT_10901]} x={820} y={217} unit="°C" max={120} HH={80} H={60} L={20} LL={10} c="lime" description="TEMPERATURE OF PIG LAUNCHER MAIN LINE DURING PIGGING"/>


    </div>
  );
}

export default PigLauncher;